import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})

export class UUIDService {
  constructor() { }


  generateUUID(): string {
    /* Expose the UUID package's uuidv4() function to generate new UUIDs. This is preferred over the browser's built in
    crypto.randomUUID() function which requires to be run from within a secure context (e.g. over HTTPS and not HTTP). */
    return uuidv4();
  }
}
